import React, {useEffect, useState} from "react"
import TrainingsList from "../../components/trainings";
import CommonTitle from "../../components/common-title";
import { getTrainingsVisible } from "../../service";
import { TrainingsData } from "../types";
import Pagination from "../../components/pagination";
import usePagination from "../../routers/usePagination";

type Trainings = Array<TrainingsData>

function Trainings() {

    const [nowLists,setNowLists] = useState<Trainings>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination();


    useEffect(() => {
        getTrainingsVisible({
            pageNum,
            status:1
        }).then(res => {
            const lists = res.data.list
            if((lists as Trainings).length > 0){
                setNowLists(list => list.concat(lists))
            }else{
                noMore()
            }
        })
    },[pageNum])

    return <div className="activity">

        <TrainingsList lists={ nowLists }/>

        <Pagination ref={pageRef} length={nowLists.length}  onChange={ (n) => setPage(n) }/>
    </div>
}

export default Trainings;
